import React, { useContext } from 'react';
import { shape, object, string, func } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { RecommendationsProvider, RecommendationsPlaceholder } from '@thd-olt-component-react/recommendations';
import classNames from 'classnames';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Card } from '@thd-olt-component-react/card';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import './custom-product-pod-details.scss';

const CustomProductPodDetails = ({
  itemId,
  reference,
  scheme,
  setClosedState
}) => {
  const {
    channel,
    store
  } = useContext(ExperienceContext);

  const resx = {
    products: itemId,
    storeId: store?.storeId,
  };

  const isMobile = channel === 'mobile';
  const currentPodContainer = reference?.current?.parentNode;
  const arrowPostion = currentPodContainer?.offsetLeft + (currentPodContainer?.offsetWidth / 2) - 32;
  const overlaySpace = classNames('custom-product-pod-details', { 'custom-product-pod-details--space': isMobile });

  return (
    <RecommendationsProvider
      ready
      resx={resx}
    >
      <Row>
        <Col className={overlaySpace}>
          <span className="custom-product-pod-details--up-arrow" style={{ left: `${arrowPostion}px` }} />
          <button
            src="https://assets.homedepot-static.com/images/v1/close-symbol-orange.svg"
            type="button"
            className="custom-product-pod-details__close-button"
            aria-label="close"
            onClick={() => { setClosedState(true); }}
          />
          {isMobile
            ? (
              <Card noHide>
                <Card.Content maxHeight="none" className="carousel-card">
                  <RecommendationsPlaceholder scheme={scheme} itemId={itemId} shouldDisplayCard />
                </Card.Content>
              </Card>
            )
            : (
              <Row>
                <Col>
                  <RecommendationsPlaceholder scheme={scheme} itemId={itemId} />
                </Col>
              </Row>
            )}
        </Col>
      </Row>
    </RecommendationsProvider>
  );
};

CustomProductPodDetails.displayName = 'CustomProductPodDetails';

CustomProductPodDetails.propTypes = {
  itemId: string.isRequired,
  reference: shape({
    // eslint-disable-next-line react/forbid-prop-types
    current: object
  }).isRequired,
  scheme: string,
  setClosedState: func.isRequired
};

CustomProductPodDetails.defaultProps = {
  scheme: 'PLP_Search_In_Stock'
};

CustomProductPodDetails.dataModel = extend({}, RecommendationsPlaceholder);

export { CustomProductPodDetails };
